import { SxProps } from '@mui/system/styleFunctionSx';
import Box from '@mui/material/Box';
import { MutableRefObject } from 'react';

interface TwoColumnLayoutProps {
  left: JSX.Element;
  right: JSX.Element;
  spaceBetween?: number;
  leftFlexBasis?: number; // A number indicating the percentage to apply to the flex-basis on the left column
  rightFlexBasis?: number; // A number indicating the percentage to apply to the flex-basis on the left column
  leftWrapperRef?: MutableRefObject<HTMLDivElement | undefined>;
  rightWrapperRef?: MutableRefObject<HTMLDivElement | undefined>;
  wrapperSX?: SxProps;
}

export function TwoColumnLayout(props: TwoColumnLayoutProps) {
  const {
    left,
    right,
    spaceBetween = 0,
    leftFlexBasis = 50,
    rightFlexBasis = 50,
    leftWrapperRef = undefined,
    rightWrapperRef = undefined,
    wrapperSX = {},
  } = props;

  return (
    <Box display={'flex'} flexDirection={'row'} width={'100%'} sx={wrapperSX}>
      <Box
        sx={{ flexBasis: `${leftFlexBasis}%`, mr: spaceBetween / 2 }}
        ref={leftWrapperRef}
      >
        {left}
      </Box>
      <Box
        sx={{ flexBasis: `${rightFlexBasis}%`, ml: spaceBetween / 2 }}
        ref={rightWrapperRef}
      >
        {right}
      </Box>
    </Box>
  );
}
